"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseDOM = void 0;
/**
 * Verifies if an application can use DOM.
 */
function canUseDOM() {
    return (
    // eslint-disable-next-line no-restricted-globals
    typeof window !== 'undefined' &&
        !!(
        // eslint-disable-next-line no-restricted-globals, deprecation/deprecation
        (window.document && window.document.createElement)));
}
exports.canUseDOM = canUseDOM;
//# sourceMappingURL=canUseDOM.js.map